/// <reference path='../../../../../typings/index.d.ts' />
/// <reference path='../../../components/baseClasses/dataMaintenanceSectionBase.ts' />

module Meevo.Plugins.MarketPricing {
    'use strict';

    import IDataMaintenanceLocations = Meevo.Plugins.MarketPricing.IDataMaintenanceLocations;

    export class MembershipGrandfather extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IDataMaintenanceLocations> {
        public locationsFilter: any;
        public locations: any;
        public criteriaMembershipBenefitTemplate: any;
        public today: Date;

        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService,
                    protected scheduleLocationService: Meevo.Plugins.MarketPricing.ScheduleLocationService) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings
            );

            this.today = new Date();
            this.today.setHours(0,0,0,0);
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void { }

        /**
        * When tab is activated
        * */
        public sectionModelRetrieved(): void {
            this.sectionEndpoint = 'LocationTransfer';

            if (this.model == '' && !this.model.locationsToTransfer) {
                this.params.dataService.getSectionById(this.baseEndpoint, this.parentItemId, this.sectionEndpoint).then((response) => {
                    this.model = response;
                });
            }
        }

        /**
         * Save
         * */
        public preSave(): any {
            this.sectionEndpoint = 'Grandfather';

            this.model = this.scheduleLocationService.prepareGrandfatherModel(this.model);
        }

        public addTypeaheadAllValue(response, request): void {
            let allValueItem = _.find(response, function (item) {
                return item['id'] === null;
            });

            if (!allValueItem && request.pageNumber === 0) {
                let itemAll = {
                    id: null,
                    displayName: 'All'
                };
                response.unshift(itemAll);
            }
        }

        public expandLocationCallback(index, id) {
            let el = _.findWhere(this.model.locationsToTransfer, { locationId: Number(id) });

            if (!el.membershipTypeSettings) {
                this.scheduleLocationService.getGrandfatherInfo(el, this.baseEndpoint, this.parentItemId, this.model['priceGroupQueueId']);
            }
        }

        private getGrandfatherInfo(el) {
            this.params.busyService.start();

            let id = this.model['priceGroupQueueId'] || this.parentItemId;

            return this.dataService.getItem(this.baseEndpoint, id, 'Grandfather/' + el.locationId).then((data: any) => {
                el.membershipTypeSettings = data;

                _.each(data, (type: any) => {
                    type.membershipBenefitTemplate = {
                        displayName: type.membershipBenefitTemplateDisplayName,
                        id: type.membershipBenefitTemplateId,
                    };

                    _.each(type.membershipTypeSnapshotPoints, (snapshot: any) => {
                        snapshot.membershipBenefitTemplate = {
                            displayName: snapshot.membershipBenefitTemplateDisplayName,
                            id: snapshot.membershipBenefitTemplateId,
                        }
                    });
                });

                this.params.busyService.stop();
                return el;
            });
        }

        /**
         * If the section instance manages it's own state, this evaluates whether it is in 'Readonly' mode.
         * @return {boolean}
         */
        get isReadonly(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Readonly;
        }

        public isHidePricing(membershipType, snapshot): boolean {
            let res = false;
            if (snapshot && snapshot.membershipPricing !== true && snapshot.snapshotPointMembershipPricing) {
                res = true;
                membershipType.membershipPricing = false;
            }
            return res;
        }

        public isHideBenefitTemplatePricing(membershipType, snapshot): boolean {
            let res = false;
            if (snapshot && snapshot.benefitTemplatePricing !== true && snapshot.snapshotPointBenefitTemplatePricing) {
                res = true;
                membershipType.benefitTemplatePricing = false;
            }
            return res;
        }

        public isHideBenefitTemplate(membershipType: any): boolean {
            let res = false;
            if (membershipType && membershipType.benefitTemplatePricing !== true) {
                res = true;
                membershipType.membershipBenefitTemplate = null;
            }
            if (this.isReadonly) {
                res = true;
            }
            return res;
        }

        public setCriteriaMembershipBenefitTemplate(location, membershipType): void {
            this.criteriaMembershipBenefitTemplate = {
                includeActive: true,
                membershipTypeId: membershipType.membershipTypeId,
                coSearchType: 1,
                coFilterByLocationId: location.locationId,
                location: {
                    id: location.locationId,
                    storeName: location.locationName,
                    storeNumber: location.locationNumber,
                }
            }
        }

        // Add "No Change" to typeahead
        public addTypeaheadNoChangeValue(response, request): void {
            let allValueItem = _.find(response, function (item) {
                return item['id'] == null;
            });

            if (!allValueItem && request.pageNumber === 0) {
                let itemAll = {
                    id: null,
                    displayName: 'No change'
                };
                response.unshift(itemAll);
            }
        }

        changedMemberBenefitTemplate(membershipType) {
            membershipType.membershipBenefitTemplateId = membershipType.membershipBenefitTemplate.id;
        }

    }
}